import React, { Component } from 'react';
import { NormalButton } from './components';
import {
  inject,
  observer,
} from 'mobx-react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import Stopwatch from '../Stopwatch/Stopwatch';
import moment from 'moment';
import { IconDirection } from '../../constants/BatchTypeEnums';
import { beltSwitch } from '../../stores/batch/device-switches/belt-switch';

export const BeltStartMode = {
  WeightingLastMaterial: 1,
  BeforeDelay: 2,
  BeginsDischarge: 3,
  FinishedWeighting: 4,
};

@inject('batchStore', 'devicesStore')
@observer
class Belt extends Component {
  changeBeltSize = increase => {
    const { device, devicesStore } = this.props;
    let { size } = device;
    const minSize = 3;
    const maxSize = 15;
    if (size < minSize) {
      size = minSize + 1;
    }
    if (size > maxSize) {
      size = maxSize - 1;
    }

    const newSize = size + (increase ? 1 : -1);

    if (newSize >= minSize && newSize <= maxSize) {
      devicesStore.updateDevice(device.id, device.deviceTypeName, { ...device, size: newSize });
    }
  };

  renderIcons() {
    const { size } = this.props.device;
    const beltSize = !size || size < 3 || size > 15 ? 5 : size;
    const arr = Array.apply(null, Array(beltSize));
    return (
      <div>
        <div className="device-icon body body-left"/>
        <div className="device-icon gear left"/>
        {arr.map((v, i) => (
          <div key={i} className={`device-icon device-icon-wrap device-icon-${i}`}>
            <div className="device-icon body body-middle"/>
            {i === arr.length - 1 && (
              <div className="device-icon groove-wrapper">
                <div className="device-icon groove"/>
              </div>
            )}
            {i > 0 &&
            <div className="device-icon gear middle"/>
            }
            {i > 0 &&
            <div className="device-icon wheel middle"/>
            }
            {i === arr.length - 1 &&
            <div className="device-icon gear right"/>
            }
            {i === arr.length - 1 &&
            <div className="device-icon body body-right"/>
            }
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { device, batchStore } = this.props;
    const { active, startTime } = batchStore.getDeviceStatus(device.id);
    let diff = 0;
    if (startTime) {
      const endTime = moment();
      diff = Math.round(endTime.diff(startTime) / 1000);
    }
    const isActive = batchStore.isOutputOn(device.onPNo) || (device.offPNo && !!active && diff > 0) ? 'active' : '';
    const isOn = !!isActive || !!active;
    const btnClass = isOn ? 'active btn-batch-red' : 'btn-batch-green';
    const direction = device.direction === IconDirection.Left ? 'direction-left' : 'direction-right';
    const errorClass = device.runningStatusPNo && isOn && !batchStore.isInputPortOff(device.runningStatusPNo)
            && !batchStore.isOverride ? 'error' : '';

    return (
      <div id={`device-${device.id}`} className={`${isActive} ${direction} device-gui device-gui--belt device-gui--belt__type1 device-icon-${device.icon} ${errorClass}`}>
        {this.renderIcons()}
        <div className="device-label device-label--horizontal">
          <div className="device-type" title={`#${device.id}`}>{device.description || `#${device.id}`}</div>
          <div className="status status-counter"><Stopwatch start={isOn} startTime={diff} stop={!isOn} delay={device.onDelay}/></div>
        </div>

        <button className="device-icon btn btn-belt-size right"
          title="Longer"
          onClick={() => this.changeBeltSize(true)}>{' '}
        </button>
        <button className="device-icon btn btn-belt-size left"
          title="Shorter"
          onClick={() => this.changeBeltSize(false)}>{' '}
        </button>
        <div className="device-gui__row">
          <NormalButton className={`btn-batch ${btnClass}`}
            onClick={() => beltSwitch(batchStore.rootStore, device.id, !isOn, true)}>
            <i className="fa fa-power-off" />
          </NormalButton>
        </div>
      </div>
    );
  }
}

export default deviceDOMHoc(Belt);
